/**
 * Geçersiz vekalet köprüsü (089) — `authBridge`'in 401 için yaptığının vekalet karşılığı.
 *
 * <p>Sunucu, çalışma sırasında geçersizleşen bir persona için `PROXY_NOT_ACTIVE` (403) döner. Bu
 * çapraz-kesen bir durumdur: hangi ekranda olunduğundan bağımsız olarak kullanıcı kendi personasına
 * düşürülmeli, bilgilendirilmeli ve anasayfaya alınmalıdır. Kancaya bağlanan gerçek davranış
 * `useProxyInvalidRecovery`'dedir; interceptor React'e doğrudan erişemediği için araya bu köprü girer.
 */

/** Sayfa açıkken uçuşta olan birkaç istek aynı anda reddedilebilir; tek kurtarma yeterlidir. */
const DEDUP_WINDOW_MS = 3000

let handler: (() => void) | null = null
let lastTriggeredAt = 0

export function setProxyInvalidHandler(fn: (() => void) | null): void {
  handler = fn
}

/**
 * `PROXY_NOT_ACTIVE` alındığında çağrılır.
 *
 * @returns Bu çağrı gerçekten tetikledi mi (`true`) yoksa deduplike mi edildi (`false`). Çağıran
 * yalnız `true` dönünce bilgilendirme mesajını gösterir — aksi hâlde aynı olay için üst üste
 * birkaç toast basılırdı.
 */
export function onProxyInvalid(): boolean {
  const now = Date.now()
  if (now - lastTriggeredAt < DEDUP_WINDOW_MS) return false
  lastTriggeredAt = now
  handler?.()
  return true
}

/** Test yardımcısı: modül durumunu sıfırla. */
export function __resetProxyBridge(): void {
  handler = null
  lastTriggeredAt = 0
}
